import { render } from "./App.vue?vue&type=template&id=4a19a077"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4a19a077&lang=scss"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__